"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantSecretsActions = exports.MerchantSecretType = void 0;
var MerchantSecretType;
(function (MerchantSecretType) {
    MerchantSecretType[MerchantSecretType["STRING"] = 0] = "STRING";
    MerchantSecretType[MerchantSecretType["JSON"] = 1] = "JSON";
})(MerchantSecretType || (exports.MerchantSecretType = MerchantSecretType = {}));
var MerchantSecretsActions;
(function (MerchantSecretsActions) {
    MerchantSecretsActions["CREATE"] = "merchant_secrets:create";
    MerchantSecretsActions["UPDATE"] = "merchant_secrets:update";
    MerchantSecretsActions["FIND"] = "merchant_secrets:find";
    MerchantSecretsActions["BULK_FIND"] = "merchant_secrets:bulkFind";
    MerchantSecretsActions["DELETE"] = "merchant_secrets:delete";
})(MerchantSecretsActions || (exports.MerchantSecretsActions = MerchantSecretsActions = {}));
//# sourceMappingURL=merchant_secrets_service.js.map